import { Button, Dropdown, Input, Modal, Space } from "antd";
import styles from "../../../../styles/dialog.module.scss";
import { useState } from "react";
import { invoiceOptions } from "..";
import { CaretDownOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { PaymentOption } from "../types";
import {useLazyQuery, useMutation} from "@apollo/client";
import { CONFIRM_INVOICE_PAYMENT } from "../../../../api/graphql/payments";

interface BalanceModalProps {
  userId: number;
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  onOk: () => void;
  onSave: (value: { balance: number; invoiceType: PaymentOption }) => void;
  balance: number;
  title: string;
}

const BalanceModal: React.FC<BalanceModalProps> = ({
  isOpen,
  onClose,
  onSave,
  onCancel,
  onOk,
  balance,
  title,
  userId,
}) => {
  const [selectedValue, setSelectedValue] = useState(PaymentOption.INVOICE);
  const [newBalance, setBalance] = useState(0);
  const [invoiceId, setInvoiceId] = useState(0);

  const [confirmInvoice] = useMutation(CONFIRM_INVOICE_PAYMENT, {
    update(cache, { data }) {
      cache.modify({
        fields: {
          user(existingUser = {}) {
            return {
              ...existingUser,
              ...data.confirmInvoice,
            };
          },
        },
      });
    },
  });

  return (
    <Modal
      open={isOpen}
      title={<span className={styles.title}>{title}</span>}
      onOk={onOk}
      onCancel={onCancel}
      width={480}
      footer={[
        <div key="footer" className={styles.footer}>
          <Button
            className={styles.cancel}
            key="cancel"
            style={{}}
            type="default"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            className={styles.save}
            type="primary"
            onClick={async () => {
              onSave({ balance: newBalance, invoiceType: selectedValue });
              setBalance(0);
              setSelectedValue(PaymentOption.INVOICE);
              await confirmInvoice({
                variables: {
                  isBonus: selectedValue === PaymentOption.BONUS,
                  amount: newBalance,
                  invoiceId,
                  userId,
                },
              });
              onClose();
            }}
          >
            Save
          </Button>
        </div>,
      ]}
    >
      <Input
        value={balance}
        className={styles.dropdown}
        disabled
        onChange={(e) => setBalance(Number(e.target.value))}
        style={{ width: "100%" }}
        prefix={"$"}
      />
      <Dropdown
        menu={{
          ...invoiceOptions,
          onClick: ({ key }) => setSelectedValue(Number(key)),
        }}
      >
        <Button className={styles.dropdown}>
          <Space className={styles.selected}>
            {
              invoiceOptions.items.find((item) => item.key == selectedValue)
                ?.label
            }
            <CaretDownOutlined />
          </Space>
        </Button>
      </Dropdown>

      <Input
        type="number"
        step="0.01"
        min="0"
        value={newBalance}
        className={styles.dropdown}
        onChange={(e) => setBalance(parseFloat(e.target.value) || 0)}
        style={{ width: "100%" }}
        prefix={"$"}
      />
      {selectedValue === PaymentOption.INVOICE && (
        <>
          <span className={styles.label}>Invoice id</span>
          <Input
            value={invoiceId}
            className={styles.dropdown}
            onChange={(e) => setInvoiceId(Number(e.target.value))}
            style={{ width: "100%" }}
            // prefix={"$"}
          />
        </>
      )}
    </Modal>
  );
};

BalanceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  balance: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired
};

export default BalanceModal;
